export const defaultAispGocardlessFlowRedirectionConfig: { [key in NominatedAccountStatusEnum]: string } = {
  connected: '/zones/landing/home/(modal:modal/landing/account-connected-successfully)',
  'not-connected': '/zones/landing/home/(modal:modal/landing/account-connected-successfully)',
  'many-accounts': '/zones/landing/home/(modal:modal/landing/account-selection)',
  processing: '/zones/landing/home/(modal:modal/landing/account-connected-successfully)',
  rejected: '/zones/landing/home/(modal:modal/landing/account-connected-successfully)',
  expired: '/zones/landing/home/(modal:modal/landing/account-connected-successfully)',
  error: '/zones/landing/home/(modal:modal/landing/account-connected-successfully)',
};

export enum NominatedAccountStatusEnum {
  CONNECTED = 'connected',
  NOT_CONNECTED = 'not-connected',
  PROCESSING = 'processing',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  ERROR = 'error',
  MANY_ACCOUNTS = 'many-accounts',
}
